import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-materialize';
import _ from 'lodash';
import { saveCardAction } from 'components/Steps/CustomCard/modules/actions';
import Likes from 'components/Steps/Likes';
import UsersModal from 'components/UsersModal';
import moment from 'moment';
import Deliverable from './Deliverable';
import { Title, SliderWrapper } from './styles';

function printSlider(props) {
  const { children, onChange } = props;

  const handleClick = (event) => {
    event.stopPropagation();
  };

  return (
    <SliderWrapper onMouseDown={handleClick}>
      <Carousel
        carouselId={`Carousel-${moment().unix()}`}
        options={{
          dist: -20,
          duration: 200,
          fullWidth: false,
          indicators: false,
          noWrap: false,
          numVisible: 5,
          onCycleTo: onChange,
          padding: -170,
          shift: 0,
        }}
      >
        {children}
      </Carousel>
    </SliderWrapper>
  );
}

const MySlider = React.memo(printSlider);

function Deliverables(props) {
  const {
    actualContext: context, app, elements: startElements,
    onClose, showClose, showLike, title,
  } = props;
  const [actualSlide, setActualSlide] = useState(0);
  const [userSelected, setUserSelected] = useState(null);
  const [elements, setElements] = useState(startElements);

  const getColor = () => {
    let color = app.color1;

    if (context && context.color) {
      color = typeof context.color === 'string' ? context.color : context.color.color;
    }

    return color;
  };

  const handleSwipe = (newSlide) => {
    setActualSlide(newSlide);
  };

  const handleLike = (id) => {
    const element = _.find(elements, { id });
    element.like = +!element.like;
    setElements([...elements]);

    saveCardAction('like', `element*___*${id}`, id);
  };

  const handleCloseFeedbackUsers = () => {
    setUserSelected(null);
  };

  const handleClickLike = (like) => {
    setUserSelected(like);
  };

  const changeSlide = (slide) => {
    const position = parseInt(window.$(slide).attr('data-position'), 10);
    handleSwipe(position);
  };

  useEffect(() => {
    return (() => {
      window.M.Carousel.getInstance(window.$('.carousel:first')).destroy();
    });
  }, []);

  const printCards = () => {
    const color = getColor();
    return _.map(elements, (element, index) => {
      return (<div key={index} data-position={index}><Deliverable element={element} color={color} onLike={handleLike} onClose={onClose} showClose={showClose} showLike={showLike} total={elements.length} position={index} /></div>);
    });
  };

  const printSelectedUser = () => {
    if (userSelected) {
      return (
        <UsersModal
          usersIds={_.map(elements[actualSlide].users, user => user.id)}
          userSelected={userSelected}
          onEnd={handleCloseFeedbackUsers}
        />
      );
    }

    return null;
  };

  const color = getColor();
  const SliderCards = useMemo(() => (
    <MySlider onChange={changeSlide}>{printCards()}</MySlider>
  ), [startElements]);

  return (
    <React.Fragment>
      {printSelectedUser()}
      {
        title && (
          <div className='title_card_wrapper'>
            <Title dangerouslySetInnerHTML={{ __html: title }} backgroundColorText={color} />
          </div>
        )
      }
      {SliderCards}
      <Likes
        label={elements[actualSlide].name}
        userList={elements[actualSlide].users}
        onSelectUser={handleClickLike}
      />
    </React.Fragment>
  );
}

Deliverables.propTypes = {
  title: PropTypes.string,
  elements: PropTypes.array.isRequired,
  app: PropTypes.object.isRequired,
  actualContext: PropTypes.object,
  showClose: PropTypes.bool,
  onClose: PropTypes.func,
};
Deliverables.defaultProps = {
  title: null,
  showClose: false,
  onClose: null,
  actualContext: null,
};

export default Deliverables;



// WEBPACK FOOTER //
// ./src/components/Steps/Deliverables/components/Deliverables.jsx